var set = require('regenerate')(0xA92E);

set.addRange(0x1000, 0x109F).addRange(0xA9E0, 0xA9FE).addRange(0xAA60, 0xAA7F);
module.exports = set;